import { DesignTokens } from "../../types"

export const createBackgroundColors: (
  foundation: DesignTokens.Foundation,
) => DesignTokens.BackgroundColors = ({ colors }) => ({
  default: colors.white,
  disabled: colors.gray050,
  hover: colors.gray050,
  subdued: colors.gray050,
  discount: colors.green050,
  brandQuiet: colors.green200,
  brand: colors.green400,
  brandHover: colors.green600,
  notification: colors.red600,
  urgent: colors.red050,
  accent: colors.purple600,
  informational: colors.blue050,
  success: colors.green050,
  error: colors.red050,
  attention: colors.yellow050,
  selectionQuiet: colors.blue050,
  selection: colors.blue400,
  selectionHover: colors.blue600,
  action: colors.blue400,
  actionHover: colors.blue600,
  inverse: colors.black,
  overlay: colors.blackAlpha60[700],
  lightOverlay: colors.blackAlpha60[100],
  warning: colors.yellow600,
})
